import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  IonicPage,
  Loading,
  Modal,
  ModalController,
  NavController,
  NavParams,
  Platform,
  Popover,
  Select
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {AppConfigPage} from "../app-config/app-config";
import {CycleCountService} from "../../providers/cyclecount.service";
import {VizixService} from "../../providers/vizix.service";
import {DepartmentsZones, ZoneType} from "../../models/zoneDeptRelation";
import {ReaderService} from "../../providers/reader.service";
import {PadUpcPipe} from "../../pipes/validate-tag/pad-upc";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {SimulatorService} from "../../providers/simulator.service";
import {VizixEventService} from "../../providers/vizix.event.service";
import {
  NAV_PARAM_FILTERED_RESPONSE,
  NAV_PARAM_RETURN_PAGE,
  NAV_PARAM_SELECTED_FILTERS,
  RETURN_PAGE_CYCLE_COUNT
} from "../../app/app.constants";
import {DeviceSelectPage} from "../device-select/device-select";
import {FilterItem} from "../../models/FilterItem";
import {CycleCountFiltersModal} from "./cycle-count.filters.modal";
import {FilterItemValue} from "../../models/FilterItemValue";
import {Subscription} from "rxjs/Subscription";
import {InsomniaService} from "../../providers/insomnia.service";
import {FormatDataTypePipe} from "../../pipes/format-data-type/format-data-type";
import {CycleCountDetailPage} from "./cycle-count.detail";
import {TableScriptReportResponse} from '../../models/TableScriptReportResponse';
import "rxjs/add/operator/finally";


/**
 * Generated class for the CycleCountPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cycle-count',
  templateUrl: 'cycle-count.html',
  providers: [PadUpcPipe, FormatDataTypePipe]
})
export class CycleCountPage {

  private tag: string = '[CYCLE_COUNT]';

  readCount = 0;
  totalReadsCount = 0;
  expectedCount = 0;
  remainingCount = 0;
  toSyncCount = 0;
  progress = 0;

  //DepartmentZones values
  private vizixDepartmentArray: Array<String> = [];
  private selectedDepartment: DepartmentsZones;
  private selectedZone: ZoneType;

  alertReaderError: Alert;
  alertReportError: Alert;
  alertReaderDisconnectedError: Alert;
  alertServerError: Alert;
  alertReaderNotConnectedError: Alert;

  readerDisconnectSubscription: Subscription;

  modalCycleCountFiltered: Modal;
  popoverProgress: Popover;
  popoverDetails: Popover;
  loading: Loading;

  isTriggerPulled = false;

  isPopPageActive: boolean = false; // Used to prevent multiple 'pop' calls

  lastDetectTime: Map<string, number> = new Map();
  is_loading: boolean = false;
  isAlertShowing: boolean = false;

  uuid: string = '';
  username: string = '';

  isDragging: boolean = false;

  filtersList: Array<FilterItem> = []; // Has all the filters (Selected ones have property 'Selected' = true)
  selectedFiltersList: Array<FilterItemValue> = []; // Has only the selected values to show or send

  modeFiltered: boolean = false;

  private isConnectedSubscription: Subscription;

  @ViewChild(Content) content: Content;
  @ViewChild('Select1') select1: Select;
  @ViewChild('Select2') select2: Select;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              private cycleCountService: CycleCountService,
              private vizixService: VizixService,
              private cdr: ChangeDetectorRef,
              private alertCtrl: AlertController,
              private modalCtrl: ModalController,
              private readerService: ReaderService,
              private platform: Platform,
              private simulatorService: SimulatorService,
              private vizixEventService: VizixEventService,
              private _insomniaService: InsomniaService) {
    //building department array
    // this.vizixDepartmentArray.push(DEPARTMENT_NAME_ALL_VALUE);
    for (let department of this.vizixService.zoneDeptList) {
      this.vizixDepartmentArray.push(department.DeptName);
    }
    console.log(this.tag, "department array", this.vizixDepartmentArray);

    this.setDefaultDeptAndZone();

    // Init Back button
    this.platform.ready().then((readySource) => {
      this.platform.registerBackButtonAction(() => {
        this.goBack();
      });
    });

    this.modeFiltered = this.vizixService.configurationApp.CycleCountConfiguration.CycleCountScreenType.value.toLowerCase() == "filtered";
  }

  ionViewDidLoad() {
    //Setting seledted Department all the first time
    /*this.selectedDepartment = this.vizixDepartmentArray[0];
    this.getZone();*/

    this.setDefaultDeptAndZone();

    this.cdr.detectChanges();

    this.cycleCountService.updateThingTypeCodeToSyncGroup();

    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );
    // Init all alerts
    this.initAlerts();

    this.initReaderStatusListenerIfConnected();
    this.vizixService.VizixUpdateReportDefinitionIdentifyTag();

    // Get the current UUID
    this.vizixEventService.getVizixEventItemBase().then(event => {
      this.uuid = event.remoteSource;
    })
  }

  initReaderStatusListenerIfConnected() {
    this.isReaderConnected().subscribe((isConnected) => {
      this.initReaderStatusListener();
    }, () => {
      if (this.simulatorService.isSimulatorEnabled) {
        this.initReaderStatusListener();
      } else {
        // this.alertReaderNotConnectedError.present();
        // this.isAlertShowing = true;
      }
    });
  }

  ionViewWillEnter() {
  }

  ionViewDidEnter() {

    this.stopReader();

    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );

    this.cdr.reattach();
    this.cdr.detectChanges();

    this.content.resize();

    this.initBackButton();
  }

  initBackButton() {
    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });
  }

  ionViewWillLeave() {
    //insomnia service with the method insomniaAllowScreenSleepAgain will screen sleep again when go to other page
    this._insomniaService.insomniaAllowScreenSleepAgain().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error allowing application sleep again');
      }
    );

    this.unsubscribeAll();
    //this.stopReader(); ==>won't use this method because a menu screen delay
    this.cdr.detach();
  }

  unsubscribeAll() {
    if (this.readerDisconnectSubscription) {
      this.readerDisconnectSubscription.unsubscribe();
    }
  }

  initAlerts() {
    this.initAlertReaderError();
    this.initAlertReportError();
    this.initAlertReaderDisconnectedError();
    this.initAlertReaderNotConnectedError();
    this.initAlertServerError();
  }

  updateZone() {
    this.selectedZone = this.selectedDepartment.Zones[0];
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReaderError() {
    this.alertReaderError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.reader_error.title'),
      message: this.translate.instant('cycle_count.alerts.reader_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.reader_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReportError() {
    this.alertReportError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.report_error.title'),
      message: this.translate.instant('cycle_count.alerts.report_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.report_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.goBack();
            this.initAlertReportError();// We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReaderDisconnectedError() {
    this.alertReaderDisconnectedError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.reader_disconnected_error.title'),
      message: this.translate.instant('cycle_count.alerts.reader_disconnected_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.reader_disconnected_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderDisconnectedError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertServerError() {
    this.alertServerError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.server_error.title'),
      message: this.translate.instant('cycle_count.alerts.server_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.server_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertServerError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when the reader is not connected and user tries to do something in the module
  initAlertReaderNotConnectedError() {
    this.alertReaderNotConnectedError = this.alertCtrl.create({
      title: this.translate.instant('menu_tracker_retail.alerts.error_pair.title'),
      message: this.translate.instant('menu_tracker_retail.alerts.error_pair.message'),
      buttons: [
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.cancel'),
          role: 'cancel',
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderNotConnectedError();
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.ok'),
          handler: () => {
            // this.isPopPageActive = true;
            this.isAlertShowing = false;
            this.initAlertReaderNotConnectedError();
            this.navCtrl.push(DeviceSelectPage, {'backToMenu': true, 'returnPage': RETURN_PAGE_CYCLE_COUNT});
            /*this.navCtrl.popToRoot().then(() => { // To prevent the page stack to increase every time
            });*/
          }
        }
      ]
    });
  }

  private setDefaultDeptAndZone() {
    let defaultDept = this.vizixService.configurationApp.AppParametersConfiguration.DefaultDepartment.value;
    let defaultZone = this.vizixService.configurationApp.AppParametersConfiguration.DefaultZone.value;

    for (let dept of this.vizixService.zoneDeptList) {
      if (defaultDept == dept.DeptName) {
        this.selectedDepartment = dept;
        for (let zone of  dept.Zones) {
          if (zone.zoneTypeCode == defaultZone) {
            this.selectedZone = zone;
            break;
          }
        }
        break;
      }
    }
  }

  openMoreFilters() {
    this.isReaderConnected().subscribe(() => {
      this.modalCycleCountFiltered = this.modalCtrl.create(CycleCountFiltersModal, {
        selectedZone: this.selectedZone,
        selectedDepartment: this.selectedDepartment
      });

      this.modalCycleCountFiltered.onWillDismiss((response: { response: TableScriptReportResponse, selectedFilters: { label: string, value: string }[] }) => {
        if (response && response.response instanceof TableScriptReportResponse) {
          this.showCycleCountScreen(response);
        } else {
          this.initBackButton();
        }
      });
      this.modalCycleCountFiltered.present();
    }, () => {
      console.log(this.tag, 'Reader not connected!');
      this.isAlertShowing = true;
      this.alertReaderNotConnectedError.present();
    });
  }

  dismissLoading() {
    this.is_loading = false;
    this.loading.dismiss();
  }

  goBack(fromTemplateBackButton ?: boolean) {
    if (!this.is_loading && !this.isAlertShowing && !this.isPopPageActive) {

      this.closeAllPopupsAndPop();

    }
  }

  closeAllPopupsAndPop() {
    if (!this.isPopPageActive) {
      if (this.select1) {
        this.select1.close();
      }
      if (this.select2) {
        this.select2.close();
      }
      if (this.isPopPageActive) {
        this.popoverProgress.dismiss();
      }
      if (this.popoverDetails) {
        this.popoverDetails.dismiss();
      }
      this.navCtrl.pop();
      this.isPopPageActive = true;
    }
  }

  goToAppConfig() {
    if (!this.isTriggerPulled) {
      let returnNavParams = {};
      returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_CYCLE_COUNT;
      this.navCtrl.push(AppConfigPage, returnNavParams);
    }
  }

  showCycleCountScreen(response?: { response: TableScriptReportResponse, selectedFilters: { label: string, value: string }[] }) {
    if (this.selectedDepartment && this.selectedZone) {
      if (this.isConnectedSubscription && !this.isConnectedSubscription.closed) {
        this.isConnectedSubscription.unsubscribe();
      }
      this.isConnectedSubscription = this.readerService.isConnected().subscribe(() => {
        let params = {
          selectedZone: this.selectedZone,
          selectedDepartment: this.selectedDepartment
        };
        if (response && response.response instanceof TableScriptReportResponse) {
          params[NAV_PARAM_FILTERED_RESPONSE] = response.response;
          params[NAV_PARAM_SELECTED_FILTERS] = response.selectedFilters;
        }
        this.navCtrl.push(CycleCountDetailPage, params);
      }, () => {
        console.log(this.tag, 'Reader not connected!');
        this.isAlertShowing = true;
        this.alertReaderNotConnectedError.present();
      });

    }
    this.content.resize();
    this.cdr.detectChanges();
  }

  // Called every time we do a reader operation
  isReaderConnected(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.readerService.isConnected().subscribe(
        (result) => {
          console.log(this.tag, 'Reader is connected', result);
          if (result) {
            observer.next(true); // Connected
          } else {
            observer.error('Reader not connected'); // Not connected
          }
        },
        (error) => {
          observer.error('Reader not connected'); // Not connected
        }
      );
    });
  }

  stopReader() {
    this.isReaderConnected().subscribe(() => {
      if (this.platform.is('cordova')) {
        this.readerService.stopScanCC().subscribe(
          () => {
            console.log(this.tag, 'Reader stopped successfully');
          },
          (error) => {
            console.log(this.tag, 'Error stopping reader', error);
          }
        );
      }
    }, (error) => {
      console.log(this.tag, 'ERROR', error);
    });
  }

  private initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe((response) => {
      console.log(this.tag, 'Reader status', response);
      if (response.hasOwnProperty('connected') && !response.connected) {
        console.log(this.tag, 'Reader disconnected!');
        this.isAlertShowing = true;
        this.alertReaderDisconnectedError.present();
      }
    }, (error) => {
      this.isAlertShowing = true;
      this.alertReaderError.present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/cycle-count/cycle-count.ts